module.exports = __webpack_public_path__ + "static/img/SALDRU-CMYK-landscape-clear_cropped.80a3f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SALDRU-CMYK-landscape-clear_cropped.png
// module id = WvqE
// module chunks = 1